import { ReactNode } from "react";
import clsx from "clsx";
import Loader from "@/shared/ui/Loader";

type Props = {
  isCart: boolean;
  isLoading: boolean;
  children: ReactNode;
};

export default function ShopGoodsWrapper({ isCart, isLoading, children }: Props) {
  return (
    <div
      className={clsx(
        "relative flex flex-wrap content-start gap-1.5 w-full mr-[0.8125rem] pr-[0.8125rem] pb-7.5 inset-0 overflow-y-auto overflow-x-clip [--scrollbar-width:0.25rem] [--scrollbar-track-bg:#181818] [--scrollbar-thumb-bg:#434242] [scrollbar-gutter:stable]",
        isCart && "mb-[8.25rem]",
      )}
    >
      {isLoading && <Loader />}
      {children}
    </div>
  );
}
